// Initial state is the place you define all initial values for the Redux store of the feature.
// In the 'standard' way, initialState is defined in reducers: http://redux.js.org/docs/basics/Reducers.html
// But when application grows, there will be multiple reducers files, it's not intuitive what data is managed by the whole store.
// So Rekit extracts the initial state definition into a separate module so that you can have
// a quick view about what data is used for the feature, at any time.

// NOTE: initialState constant is necessary so that Rekit could auto add initial state when creating async actions.
const initialState = {
  getProductListActionsPending: false,
  getProductListActionsError: null,
  pro_lnglistById:{},
  pro_lnglistList:[],
  pro_lnglistPage:1,
  pro_lnglistSize:10,
  pro_lnglistTotal:0,
  productListParticularsIdActionsPending: false,
  productListParticularsIdActionsError: null,
  currentProduct:null,
};

export default initialState;



// WEBPACK FOOTER //
// ./src/features/gkproduct/redux/initialState.js